export default __webpack_public_path__ + "static/screen-reporting-df22a81cb2e164520c77ac7187c1d4b4.png";